import React from 'react';
import { Document, Page, Text, View, StyleSheet, PDFViewer, Image } from '@react-pdf/renderer';
import { header_logo } from '../../../../../imports';


// Create styles
const styles = StyleSheet.create({
    page: {
        padding: 30,
        backgroundColor: '#ffffff'
    },
    header: {
        flexDirection: 'row',
        marginBottom: 30,
        borderBottom: 1,
        borderBottomColor: '#eee',
        paddingBottom: 20
    },
    logo: {
        width: 100,
        marginRight: 20
    },
    companyInfo: {
        flex: 1
    },
    companyName: {
        fontSize: 20,
        fontWeight: 'bold',
        marginBottom: 5
    },
    companyDetails: {
        fontSize: 10,
        color: '#666'
    },
    title: {
        fontSize: 24,
        fontWeight: 'bold',
        marginBottom: 20,
        textAlign: 'center'
    },
    section: {
        marginBottom: 20
    },
    sectionTitle: {
        fontSize: 14,
        fontWeight: 'bold',
        marginBottom: 10
    },
    row: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderBottomColor: '#eee',
        paddingVertical: 5
    },
    label: {
        flex: 1,
        fontSize: 10,
        color: '#666'
    },
    value: {
        flex: 2,
        fontSize: 10
    },
    footer: {
        position: 'absolute',
        bottom: 30,
        left: 30,
        right: 30,
        textAlign: 'center',
        fontSize: 10,
        color: '#666',
        borderTopWidth: 1,
        borderTopColor: '#eee',
        paddingTop: 10
    }
});

const GiftCardInvoice = ({ purchase }) => {
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    return (
        <PDFViewer style={{ width: '100%', height: '600px' }}>
            <Document>
                <Page size="A4" style={styles.page}>
                    {/* Header with Logo */}
                    <View style={styles.header}>
                        <Image style={styles.logo} src={header_logo} />
                        <View style={styles.companyInfo}>
                            <Text style={styles.companyName}>PM Car Detailing</Text>
                            <Text style={styles.companyDetails}>123 Business Street</Text>
                            <Text style={styles.companyDetails}>City, State ZIP</Text>
                            <Text style={styles.companyDetails}>Phone: (123) 456-7890</Text>
                            <Text style={styles.companyDetails}>Email: info@pmcardetailing.com</Text>
                        </View>
                    </View>

                    {/* Invoice Title */}
                    <Text style={styles.title}>Gift Card Invoice</Text>

                    {/* Customer Information */}
                    <View style={styles.section}>
                        <Text style={styles.sectionTitle}>Customer Information</Text>
                        <View style={styles.row}>
                            <Text style={styles.label}>Name:</Text>
                            <Text style={styles.value}>{purchase.userName}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>Email:</Text>
                            <Text style={styles.value}>{purchase.email}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>User Type:</Text>
                            <Text style={styles.value}>{purchase.userType}</Text>
                        </View>
                    </View>

                    {/* Gift Card Details */}
                    <View style={styles.section}>
                        <Text style={styles.sectionTitle}>Gift Card Details</Text>
                        <View style={styles.row}>
                            <Text style={styles.label}>Car Type:</Text>
                            <Text style={styles.value}>{purchase.giftCard.carType}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>Service:</Text>
                            <Text style={styles.value}>{purchase.giftCard.service}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>Price:</Text>
                            <Text style={styles.value}>${purchase.giftCard.price}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>Status:</Text>
                            <Text style={styles.value}>{purchase.status}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>Purchase Date:</Text>
                            <Text style={styles.value}>{formatDate(purchase.purchaseDate)}</Text>
                        </View>
                    </View>

                    {/* Footer */}
                    <View style={styles.footer}>
                        <Text>Thank you for your purchase!</Text>
                        <Text>This gift card is subject to our terms and conditions.</Text>
                    </View>
                </Page>
            </Document>
        </PDFViewer>
    );
};

export default GiftCardInvoice;